import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { ContentViewModel, HelpPageNamesEmployerMyPages } from '@fora-monorepo/employer-my-pages-common/types';
import { trackException, trackTrace } from '@fora-monorepo/webapp-analytics';
import { HelpPageContentViewModel } from '@fora-monorepo/epi-content-common';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';
import { mockContent } from './mocks/mockContent';
import { mockHelpPageContent } from './mocks/mockHelpPageContent';

export const getPagesContent = createAsyncThunk('getPagesContent', async (_, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockContent;
  }

  return axios
    .get(`${envConfig.bffBaseUri}/content`)
    .then(res => {
      if (res.status === 200) {
        return res.data as ContentViewModel;
      }
    })
    .catch(err => {
      trackException(err);
      return thunkAPI.rejectWithValue(createThunkError('Could not get content', err));
    });
});

export const getHelpPageContent = createAsyncThunk(
  'getHelpPageContent',
  async (data: { page: HelpPageNamesEmployerMyPages }, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 800));
      return mockHelpPageContent;
    }

    return axios
      .get(`${envConfig.bffBaseUri}/content/help/${data.page}`)
      .then(res => {
        if (res.status === 200) {
          const content = res.data as HelpPageContentViewModel;
          if (!content.ingress?.body && (!content.helpSections || content.helpSections.length === 0)) {
            trackTrace(`Epi returned no content for ${data.page}`, SeverityLevel.Error);
          }

          return content;
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get content', err));
      });
  }
);
